import { render, staticRenderFns } from "./bindArea.vue?vue&type=template&id=0cb24829&scoped=true&"
import script from "./bindArea.vue?vue&type=script&lang=ts&"
export * from "./bindArea.vue?vue&type=script&lang=ts&"
import style0 from "./bindArea.vue?vue&type=style&index=0&id=0cb24829&lang=scss&scoped=true&"
import style1 from "./bindArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb24829",
  null
  
)

export default component.exports